var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "painel-flutuante d-flex justify-end",
      attrs: { "data-test": "painel-flutuante" }
    },
    [
      _c("transition", { attrs: { name: "painel-flutuante-troca" } }, [
        _vm.recolhido
          ? _c(
              "button",
              {
                key: "recolhido",
                staticClass:
                  "painel-flutuante__recolhido d-inline-flex align-center justify-center",
                attrs: {
                  type: "button",
                  "aria-expanded": "false",
                  "aria-label": _vm.copy.EXPANDIR,
                  title: _vm.copy.EXPANDIR,
                  "data-test": "painel-flutuante-expandir"
                },
                on: { click: _vm.expandir }
              },
              [
                _vm.anelNoRecolhido
                  ? _c(
                      "PainelAnelProgresso",
                      _vm._b({}, "PainelAnelProgresso", _vm.propsDoAnel, false)
                    )
                  : _c("icon-svg", {
                      attrs: {
                        name: _vm.ICONE_DAS_ENTREGAS,
                        size: _vm.TAMANHO_DO_ICONE_DO_PAINEL,
                        color: "var(--neutral-700)"
                      }
                    }),
                _vm.totalDeEntregas
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "painel-flutuante__recolhido-contagem ia-texto-micro",
                        attrs: {
                          "data-test": "painel-flutuante-recolhido-contagem"
                        }
                      },
                      [_vm._v(_vm._s(_vm.totalDeEntregas))]
                    )
                  : _vm._e()
              ],
              1
            )
          : !_vm.oculto
          ? _c(
              "nav",
              {
                key: "cartao",
                staticClass: "painel-flutuante__cartao",
                class: {
                  "painel-flutuante__cartao--sobreposto": _vm.sobreposto
                },
                style: _vm.estiloDoCartao,
                attrs: {
                  "aria-label": _vm.copy.ARIA,
                  "data-test": "painel-flutuante-cartao"
                }
              },
              [
                _c(
                  "button",
                  {
                    staticClass:
                      "painel-flutuante__recolher d-inline-flex align-center justify-center",
                    attrs: {
                      type: "button",
                      "aria-expanded": "true",
                      "aria-label": _vm.copy.RECOLHER,
                      title: _vm.copy.RECOLHER,
                      "data-test": "painel-flutuante-recolher"
                    },
                    on: { click: _vm.recolher }
                  },
                  [
                    _c("icon-svg", {
                      attrs: {
                        name: _vm.ICONE_DE_RECOLHER,
                        size: _vm.TAMANHO_DO_ICONE_DO_CONTROLE,
                        color: "var(--neutral-600)"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "painel-flutuante__corpo d-flex flex-column az-gap pa-3"
                  },
                  [
                    _vm.temPlano
                      ? _c(
                          "section",
                          {
                            staticClass: "d-flex flex-column az-gap-small",
                            attrs: { "data-test": "painel-flutuante-progresso" }
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "painel-flutuante__progresso d-flex align-center az-gap-small text-left",
                                attrs: {
                                  type: "button",
                                  "aria-expanded": _vm.progressoAberto
                                    ? "true"
                                    : "false",
                                  "aria-label": _vm.rotuloDoProgresso,
                                  "data-test":
                                    "painel-flutuante-progresso-alternar"
                                },
                                on: { click: _vm.alternarProgresso }
                              },
                              [
                                _c(
                                  "PainelAnelProgresso",
                                  _vm._b(
                                    {},
                                    "PainelAnelProgresso",
                                    _vm.propsDoAnel,
                                    false
                                  )
                                ),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "painel-flutuante__texto d-flex flex-column"
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "d-inline-flex align-center az-gap-xxsmall az-text-primary az-size-14 font-weight-medium"
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.copy.PROGRESSO) + " "
                                        ),
                                        _c("icon-svg", {
                                          staticClass:
                                            "painel-flutuante__chevron",
                                          class: {
                                            "painel-flutuante__chevron--aberto":
                                              _vm.progressoAberto
                                          },
                                          attrs: {
                                            name: _vm.ICONE_DE_AVANCAR,
                                            size:
                                              _vm.TAMANHO_DO_ICONE_DO_CONTROLE,
                                            color: "var(--neutral-600)"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ia-sidebar-aux text-truncate",
                                        attrs: {
                                          "data-test":
                                            "painel-flutuante-progresso-resumo"
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.resumoExibido.titulo))]
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c("v-expand-transition", [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.progressoAberto,
                                      expression: "progressoAberto"
                                    }
                                  ],
                                  attrs: {
                                    "data-test": "painel-flutuante-etapas"
                                  }
                                },
                                [
                                  _c("PainelSecaoProgresso", {
                                    attrs: {
                                      "sem-titulo": "",
                                      passos: _vm.progressoExibido,
                                      compacto: "",
                                      "turno-parado": !_vm.turnoEmVoo,
                                      "max-visiveis":
                                        _vm.MAXIMO_DE_ETAPAS_VISIVEIS
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.linhasDeEntrega.length
                      ? _c(
                          "section",
                          {
                            staticClass:
                              "painel-flutuante__entregas d-flex flex-column az-gap-xxsmall",
                            attrs: { "data-test": "painel-flutuante-entregas" }
                          },
                          [
                            _c(
                              "h3",
                              {
                                staticClass:
                                  "az-text-primary az-size-14 font-weight-medium d-flex align-center az-gap-small ma-0 mb-1"
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.copy.ENTREGAS) + " "),
                                _c(
                                  "span",
                                  {
                                    staticClass: "ia-sidebar-contador",
                                    attrs: {
                                      "data-test":
                                        "painel-flutuante-entregas-contagem"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.totalDeEntregas))]
                                )
                              ]
                            ),
                            _c(
                              "ul",
                              {
                                ref: "listaDeEntregas",
                                staticClass:
                                  "painel-flutuante__lista d-flex flex-column",
                                style: _vm.estiloDaListaDeEntregas,
                                attrs: {
                                  "data-test":
                                    "painel-flutuante-lista-de-entregas"
                                }
                              },
                              _vm._l(_vm.linhasDeEntrega, function(item) {
                                return _c(
                                  "li",
                                  { key: item.linha.identidade },
                                  [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "painel-flutuante__entrega d-flex align-center az-gap-small text-left",
                                        attrs: {
                                          type: "button",
                                          title: item.linha.titulo,
                                          "aria-current": item.ariaCurrent,
                                          "data-test":
                                            "painel-flutuante-entrega"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.escolherEntrega(
                                              item.linha
                                            )
                                          },
                                          mouseenter: function($event) {
                                            _vm.entregaEmHover =
                                              item.linha.identidade
                                          },
                                          mouseleave: function($event) {
                                            _vm.entregaEmHover = null
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "painel-flutuante__tile d-inline-flex align-center justify-center flex-shrink-0"
                                          },
                                          [
                                            item.linha.emAndamento
                                              ? _c("v-progress-circular", {
                                                  attrs: {
                                                    indeterminate: "",
                                                    size:
                                                      _vm.TAMANHO_DO_ICONE_DA_ENTREGA,
                                                    width: 1.5,
                                                    color: "primary",
                                                    "data-test":
                                                      "painel-flutuante-entrega-em-andamento"
                                                  }
                                                })
                                              : _c("icon-svg", {
                                                  staticClass:
                                                    "navbar-main-icon",
                                                  class: item.classesDoIcone,
                                                  attrs: {
                                                    name: item.linha.icone,
                                                    size:
                                                      _vm.TAMANHO_DO_ICONE_DA_ENTREGA,
                                                    color: item.corDoIcone
                                                  }
                                                })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "painel-flutuante__texto-da-entrega d-flex flex-column"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "painel-flutuante__titulo-da-entrega az-text-primary az-size-12 text-truncate"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.linha.titulo)
                                                )
                                              ]
                                            ),
                                            item.subtituloVisivel
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "ia-sidebar-aux text-truncate",
                                                    attrs: {
                                                      "data-test":
                                                        "painel-flutuante-entrega-subtitulo"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.linha.subtitulo
                                                      )
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              }),
                              0
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.contextoDoPainel
                      ? _c("PainelSecaoContexto", {
                          attrs: { contexto: _vm.contextoDoPainel }
                        })
                      : _vm._e(),
                    _c("SuporteWhatsappCard", { attrs: { compacto: "" } })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }